import { useEffect, useState } from 'react';
import { t } from 'i18next';
import Select from 'react-select';

import './MenuButton.scss';

export default function MenuButton(props) {
    const [options, setOptions] = useState(props?.actions?.length > 0 ? props.actions : null);

    useEffect(() => {
        setOptions((prev) => (props?.actions?.length > 0 ? props.actions : prev));
    }, [props.actions]);

    return (
        <div className={props?.classes?.length > 0 ? [...props.classes, 'menu-button-container'].join(' ') : 'menu-button-container'}>
            <Select
                classNamePrefix="menu-button-select"
                isSearchable={false}
                menuPlacement={'auto'}
                options={options}
                placeholder={<span>{props.children}</span>}
                value={null}
                formatOptionLabel={(option) => (
                    <div
                        className="menu-button-select__option"
                        onClick={() => {
                            if (typeof option.action === 'function') option.action(t(option.labelKey));
                        }}
                    >
                        <span>{t(option.labelKey)}</span>
                    </div>
                )}
            />
        </div>
    );
}
